import { SERVICE_OPTIONS, formatServiceName } from '../../constants';

interface ServicesSectionProps {
  selectedServices: string[];
  errors: Record<string, string>;
  onToggle: (service: string) => void;
}

/**
 * ServicesSection component for selecting services offered
 */
export function ServicesSection({ selectedServices, errors, onToggle }: ServicesSectionProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        Services Offered <span className="text-red-500">*</span>
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {SERVICE_OPTIONS.map((service) => (
          <label key={service} className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={selectedServices.includes(service)}
              onChange={() => onToggle(service)}
              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
              aria-invalid={!!errors.servicesOffered}
            />
            <span className="text-sm text-gray-700">{formatServiceName(service)}</span>
          </label>
        ))}
      </div>
      {errors.servicesOffered && (
        <p className="text-red-600 text-sm mt-2" role="alert">
          {errors.servicesOffered}
        </p>
      )}
    </div>
  );
}
